import React, { useState } from 'react';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';
import usePageMeta from '../../hooks/usePageMeta';

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(12),
    marginBottom: theme.spacing(10),
    maxWidth: 700,
    textAlign: 'left',
  },
  section: {
    marginTop: theme.spacing(5),
  },
  paragraph: {
    marginBottom: theme.spacing(2),
    lineHeight: 1.8,
  },
  contactBox: {
    marginTop: theme.spacing(4),
    padding: theme.spacing(4),
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 8,
  },
  label: {
    fontWeight: 600,
    marginBottom: theme.spacing(0.5),
  },
  item: {
    marginBottom: theme.spacing(3),
  },
}));

export default function Contact() {
  const classes = useStyles();
  usePageMeta('Contact Us', 'Get in touch with The Warrior Tribe team for support, feedback, or questions about the Chrome extension.');

  return (
    <Container className={classes.root}>
      <Typography variant="h3" gutterBottom>
        Contact Us
      </Typography>
      <Typography variant="body1" className={classes.paragraph}>
        We are a small, independent team focused on building practical tools for digital wellbeing and habit recovery. We read every message we receive and respond personally.
      </Typography>

      <Box className={classes.contactBox}>
        <div className={classes.item}>
          <Typography variant="subtitle1" className={classes.label}>
            General inquiries &amp; support
          </Typography>
          <Typography variant="body1">
            <Link href="mailto:support@thewarriortribe.xyz" color="primary">
              support@thewarriortribe.xyz
            </Link>
          </Typography>
          <Typography variant="body2" color="textSecondary" style={{ marginTop: 4 }}>
            We aim to respond within 1–2 business days.
          </Typography>
        </div>

        <div className={classes.item}>
          <Typography variant="subtitle1" className={classes.label}>
            Billing &amp; subscription issues
          </Typography>
          <Typography variant="body1">
            <Link href="mailto:support@thewarriortribe.xyz" color="primary">
              support@thewarriortribe.xyz
            </Link>
          </Typography>
          <Typography variant="body2" color="textSecondary" style={{ marginTop: 4 }}>
            Include your account email address for faster resolution.
          </Typography>
        </div>

        <div className={classes.item}>
          <Typography variant="subtitle1" className={classes.label}>
            Privacy &amp; data requests
          </Typography>
          <Typography variant="body1">
            <Link href="mailto:support@thewarriortribe.xyz" color="primary">
              support@thewarriortribe.xyz
            </Link>
          </Typography>
          <Typography variant="body2" color="textSecondary" style={{ marginTop: 4 }}>
            To request access to, correction of, or deletion of your personal data, email us with the subject line "Data Request".
          </Typography>
        </div>
      </Box>

      <div className={classes.section}>
        <Typography variant="h5" gutterBottom>
          Frequently Asked Questions
        </Typography>
        <Typography variant="body1" className={classes.paragraph}>
          Before reaching out, you may find your answer in our{' '}
          <Link href="/" color="primary">FAQ section on the homepage</Link>. We cover questions about how the extension works, what happens during a relapse, platform support, and more.
        </Typography>
      </div>

      <div className={classes.section}>
        <Typography variant="h5" gutterBottom>
          Reporting a Blocked Site Error
        </Typography>
        <Typography variant="body1" className={classes.paragraph}>
          If you believe a website has been incorrectly blocked by the extension, email us with the URL in question and we will review it promptly. We take false positives seriously and aim to correct them within 48 hours.
        </Typography>
      </div>

      <div className={classes.section}>
        <Typography variant="h5" gutterBottom>
          About The Warrior Tribe
        </Typography>
        <Typography variant="body1" className={classes.paragraph}>
          The Warrior Tribe is operated by an independent software team. We are not affiliated with the NoFap organization or subreddit. Our mission is to provide practical, privacy-respecting tools that help people build better digital habits. Learn more on our{' '}
          <Link href="/about" color="primary">About page</Link>.
        </Typography>
      </div>
    </Container>
  );
}
